<template>
  <div>
    <!-- Breadcrumb start -->
    <section class="bradcrumb_sec">
      <div class="container-fluid custome_container">
        <div class="row justify-content-center">
          <div class="col-md-11">
            <div class="bread_crumb_box d-md-flex align-items-start justify-content-between">
              <div class="">
                <h2 class="heading_2 font_bold mb_23">
                  Ergo <span class="text_primary">essentials</span>
                </h2>
                <nav aria-label="breadcrumb">
                  <ol class="breadcrumb">
                    <li class="breadcrumb-item">
                      <router-link
                        class="navbar-brand m-0 p-0"
                        :to="{ name: 'user_home' }"
                      >
                        Home
                      </router-link>
                    </li>
                    <li class="breadcrumb-item active" aria-current="page">
                      Ergo Essentials
                    </li>
                  </ol>
                </nav>
              </div>
            </div>
            <h3
                class="heading_3 font_bold mb_23 text-center"
               v-if="
                 client_type === '4' && (ergo_essentials_heading || '').trim().length > 0
               "
              >
                {{ ergo_essentials_heading }}
              </h3>
          </div>
        </div>
      </div>
    </section>
    <!-- Breadcrumb end -->
    <section
      :class="
        !show_self_assessment_block
          ? 'work_from_office how_else_ergo mb-0'
          : 'work_from_office how_else_ergo'
      "
    >
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-md-12 col-xxl-12">
            <div class="row">
              <div
                class="col-md-6 col-lg-4"
                v-for="option in ergo_essentials_options"
                :key="option"
              >
                <div class="custome_card card2 border-0">
                  <router-link
                    :to="{ name: ergo_essentials_config[option].route }"
                  >
                    <img
                      :src="ergo_essentials_config[option].image"
                      alt="img"
                      class="mb_66"
                    />
                    <div class="card2_text_box">
                      <h5
                        class="font_bold text-center font_size_26 mb_20 text_black"
                      >
                        {{ ergo_essentials_config[option].title }}
                      </h5>
                      <p class="text-center font_size_18 mb_20 text_black">
                        {{ ergo_essentials_config[option].description }}
                      </p>
                      <p class="text_balticsea font_size_14 text_black">
                        5 minute journey
                      </p>
                    </div>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section
      class="take_an_ergonomic_parttwo mb_44"
      v-show="show_self_assessment_block"
    >
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-md-12 col-xxl-10">
            <div class="ergonomic-image pt_26 pb_26">
              <div class="overlay">
                <div class="row">
                  <div class="col-md-12 col-lg-7 col-xl-6">
                    <div class="left-section pr_60 pl_60">
                      <h6 class="sub_heading_1 font_bold mb_22 text-white">
                        Take an ergonomic self-assessment
                      </h6>
                      <p class="text-white p_20 mb_54">
                        Take a self-assessment today and see how ergo can help
                        you feel great, enjoy more energy and supercharge your
                        productivity.
                      </p>
                      <div class="mt_14">
                        <router-link
                          :to="{ name: 'self_assessment_signup' }"
                          class="btn btn_secondary font_size_16"
                          >Take a Self-Assessment
                        </router-link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {
      show_self_assessment_block: true,
      ergo_essentials_options: [],
      ergo_essentials_heading: "",
      client_type: "1",
      ergo_essentials_config: {
        "Posture Perfect": {
          route: "posture_perfect",
          image: require("../assets/images/ergo-essential/ergo-essential1.png"),
          title: "Posture Perfect",
          description:
            "Feel great and enjoy being the most impressive one in the room.",
        },
        "Sitting Pretty": {
          route: "sitting_pretty",
          image: require("../assets/images/ergo-essential/ergo-essential2.png"),
          title: "Sitting Pretty",
          description: "Learn how to sit in total comfort day in and day out.",
        },
        "Sit/Stand Basics": {
          route: "sit_stand_basics",
          image: require("../assets/images/ergo-essential/ergo-essential3.png"),
          title: "Sit/Stand Basics",
          description:
            "Do you sit or stand when you work? How about a bit of both? Learn how.",
        },
        "Typing Do’s and Don’ts": {
          route: "typing_dos_and_donts",
          image: require("../assets/images/ergo-essential/ergo-essential4.png"),
          title: "Typing Do’s and Don’ts",
          description:
            "These typing tips will protect your hands and speed you up.",
        },
        "Mousing Do’s and Don’ts": {
          route: "mousing_dos_and_donts",
          image: require("../assets/images/ergo-essential/ergo-essential5.png"),
          title: "Mousing Do’s and Don’ts",
          description:
            "Healthy mousing is key to your well being and productivity.",
        },
        "Mindful Ergonomics": {
          route: "mindful_ergonomics",
          image: require("../assets/images/ergo-essential/ergo-essential6.png"),
          title: "Mindful Ergonomics",
          description:
            "Being mindful of how you do what you do is key to staying healthy.",
        },
      },
    };
  },
  name: "ergo_essentials",
  mounted() {
    document.title = "PBErgo - " + this.$router.currentRoute.meta.page_title;
    let data = this.$store.getters["auth/authUser"];
    let company_data = data.client;

    this.client_type = company_data.client_type;
    this.ergo_essentials_heading =
      company_data.essentials.ergo_essentials_heading;
    this.ergo_essentials_options = JSON.parse(
      company_data.essentials.ergo_essentials_options || "[]"
    );

    if (company_data.site_menu_details.TakeASelfAssessment.status == 0) {
      this.show_self_assessment_block = false;
    }

    if (localStorage.getItem("employeeEmail") == null) {
      this.$router.push({ name: "login" }).catch(() => true);
    }
  },
};
</script>
